module.exports = __webpack_public_path__ + "static/media/icon-4.3b25201b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/security/2/icon-4.svg
// module id = 399
// module chunks = 0